module.exports = "<footer class=\"footer\">\n    <div class=\"container-fluid\">\n        <div class=\"copyright pull-right\">\n            &copy; {{test | date: 'yyyy'}}, made with <i class=\"fa fa-heart heart\"></i> by anonym\n        </div>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/shared/footer/footer.component.html
// module id = ../../../../../src/app/shared/footer/footer.component.html
// module chunks = main